<template>
  <div class="m-wap-ad " id="adBox">
    <i class="icon icontemp stemp-close" @click="closeAd()"></i>
    <div
      class="m-during-area"
      v-html="adInfo.adContent"
      v-if="adInfo && adInfo.adContent && pctemplate.meeting.ad.display.value"
    ></div>

    <div
      class="m-during-area"
      v-if="
        adImageInfo &&
          adImageInfo.length > 0 &&
          pctemplate.meeting.adimage.display.value
      "
    >
      <Carousel></Carousel>
    </div>

    <div class="m-during-area">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Carousel from "@/components/pc/Carousel";
export default {
  name: "AdInfo",
  props: ["adInfo", "adImageInfo", "pctemplate"],
  mounted() {
    document.getElementById("adBox").style.height =
      document.body.clientHeight -
      document.getElementsByClassName("banner-container")[0].clientHeight -
      document.getElementsByClassName("toolbar")[0].clientHeight -
      document.getElementsByClassName("discuss-box")[0].clientHeight +
      "px";
  },
  methods: {
    closeAd() {
      this.$emit("closeAd");
    }
  },
  components: {
    Carousel
  }
};
</script>
